import { IOfflineTripParcel, IOfflineDropPoint, Code } from "pcd_library";

/**
 * The parcels belonging to the drop points the current screen covers.
 *
 * offlineDropParcels accumulates every depot visited on the trip and is not
 * pruned until logout, so anything derived from the raw table - lists, counts,
 * completion - has to be scoped through here first.
 */
export const parcelsForDrop = (
  parcels: IOfflineTripParcel[],
  dropIds: string[]
): IOfflineTripParcel[] =>
  parcels.filter((parcel) => dropIds.indexOf(parcel.dropPoint) !== -1);

/** Parcels on this drop still waiting to be scanned. */
export const pendingParcels = (
  parcels: IOfflineTripParcel[]
): IOfflineTripParcel[] => parcels.filter((parcel) => !parcel.scannedAt);

/**
 * Match a scanned label to a parcel, scoped to the drop points the current
 * screen covers. Matching on qrcode/sub alone can return a parcel belonging to
 * a different depot and stamp it with this depot's scan time.
 */
export const findParcelForDrop = (
  parcels: IOfflineTripParcel[],
  dropIds: string[],
  code: Code
): IOfflineTripParcel | undefined =>
  parcelsForDrop(parcels, dropIds).find(
    (parcel) => parcel.qrcode === code.headerId && parcel.sub === code.sub
  );

/**
 * Name the depot a scanned label actually belongs to, so a wrong-depot warning
 * can tell the driver where the parcel should go. The label carries its own
 * destination, so this still names a depot the trip does not know about.
 */
export const describeLabelDestination = (
  dropPoints: IOfflineDropPoint[],
  code: Code
): string => {
  const found = dropPoints.find(
    (drop) => drop.drop === code.drop || drop.drop === code.parentDrop
  );

  return (found && (found.name || found.postcode)) || code.drop;
};
